import {
  SET_SETTINGS,
  SET_SYS_PROMPT,
  SET_USER_PROMPT,
  SET_ACCESS,
  SET_MAX_KEYS,
} from './settings.constants';


const initialState = {
  settings: {},
  systemPrompt: '',
  userPrompt: '',
  access: [],
  maxKeys: 50,
};

const userReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_SETTINGS: {
      return {
        ...state,
        settings: {...state.settings, ...payload},
      };
    }

    case SET_SYS_PROMPT: {
      return {
        ...state,
        systemPrompt: payload,
      };
    }

    case SET_USER_PROMPT: {
      return {
        ...state,
        userPrompt: payload,
      };
    }

    case SET_ACCESS: {
      return {
        ...state,
        // access — всегда массив ролей. Не-массив приходит двумя путями: с бэкенда (колонка
        // Settings.access — JSON с defaultValue: {}, т.е. у ненастроенных настроек это ОБЪЕКТ)
        // и отсюда же — payload по умолчанию равен {}, если экшен диспатчнули без аргумента.
        // Потребители зовут .flatMap/.map, а `?.` от {} не спасает — оно не null.
        access: Array.isArray(payload) ? payload : [],
      };
    }

    case SET_MAX_KEYS: {
      return {
        ...state,
        maxKeys: payload,
      };
    }

    default:
      return state;
  }
};

export default userReducer;
